import { Box, Header } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const ContentContainer = Box.withConfig({
  paddingY: '0',
  marginBottom: '$6',
});

export const ModalHeading = Header.withConfig({
  marginTop: '$2',
});

export const ModalBody = withTypography({ fontSize: 'md', my: '$2' });
